import { useContext } from 'react'

import { VendorContext } from '~/contexts'

const useVendor = () => {
  return useContext(VendorContext)
}

export default useVendor
